<template>
    <div class="text-sm flex justify-center">
        <p>Powered by <b><a href="https://combodigital.pe/?client_reference=FCCTP-USMP" target="_blank"> ComboDigital.pe</a></b></p>
    </div>
</template>

<script>
export default {
    name: "powerby",
}
</script>
